export const filterType = {
  COMPREHENSIVE_SORT: 'comprehensive_sort',
  SORT_TOTALSALES15_DESC: 'sort_totalsales15_desc',
  SORT_COMMENTCOUNT_DESC: 'sort_commentcount_desc',
  SORT_WINSDATE_DESC: 'sort_winsdate_desc',
  SORT_DREDISPRICE: 'sort_dredisprice_asc&sort_dredisprice_desc'
}

export const PREFIX_PRODUCT_DETAIL = '//npcitem.jd.hk';